<template>
  <div v-show="visible"
       class="account-shadow"
  >
    <div class="account-container">
      <span class="close" @click="close">×</span>
      <div class="desc">帐号申请</div>
      <div class="tips">温馨提示：完善信息后，我司将及时与您取得联系！</div>
      <div class="form">
        <el-form
            label-position="top"
            label-width="80px"
            model="left"
        >
        
          <el-form-item>
            <span style="font-size: 16px;color: #797979;" slot="lable">
              <span><u class="icon-name"></u></span>
              姓名
              
            </span>
            <el-input placeholder="请输入姓名" v-model="info.name" @change="inputName"></el-input>
            <div class="errMsg" v-if="infoMsg.name">{{errMsgName}}</div>
          </el-form-item>
          <el-form-item >
            <span style="width: 100px;font-size: 16px;color: #797979;" slot="lable">
              <span><u class="icon-phone"></u></span>
              电话
            </span>
            <br>
            <el-row :gutter="5">
              <el-col :span="22">
                <div >
                  <el-input class="ssssss" placeholder="请输入电话" v-model="info.telephone" @change="inputPhone" maxlength="11"></el-input>
                  <div class="errMsg" v-if="infoMsg.telephone">{{errMsgTelephone}}</div>
                </div>
              </el-col>
              <el-col :span="1">
                <div>
                  <check-code
                    :disabled="infoMsg.disabledCode"
                    style="margin-top: 0px;height: 35px;background-color: #3a76d3;color: #fff;"
                    :userName="info.name"
                    :telephone="info.telephone"
                    url="/api/getApplyAccountCode"
                  />
                </div>
              </el-col>
              </el-row>
            
            
          </el-form-item>
          <el-form-item>
            <span style="font-size: 16px;color: #797979;" slot="lable">
              <span><u class="icon-code"></u></span>
              验证码
              
            </span>
            <el-input  placeholder="请输入验证码" v-model="info.code" maxlength="6" @change="inputCode"></el-input>
            <div class="errMsg" v-if="infoMsg.code">{{errMsgCode}}</div>
          </el-form-item>
          <el-form-item>
            <span style="font-size: 16px;color: #797979;" slot="lable">
              <span><u class="icon-email"></u></span>
              邮箱
              
            </span>
            <el-tooltip  @change="inputEmail" popper-class="packageDownLoad-tooltip" content="请务必保证邮箱真实有效，后续账号相关信息将通过邮箱进行发送，谢谢！" placement="top" effect="light">
              <el-input  placeholder="请输入邮箱" v-model="info.email" @change="inputEmail"></el-input>
              
            </el-tooltip>
            <div class="errMsg" v-if="infoMsg.email">{{errMsgEmail}}</div>

          </el-form-item>
          <el-form-item >
            <span style="width: 100%;font-size: 16px;color: #797979;" slot="lable">
              <span><u class="icon-position"></u></span>
              <span>职位</span><span style="float: right;">(非必填)</span>
            </span>
            <el-input @input="handleInput" placeholder="请输入职位" v-model="info.position" @change="inputPosition"></el-input>
            <div class="errMsg" v-if="infoMsg.position">{{errMsgPosition}}</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;height: 35px;background-color: #3a76d3;" @click="submit" :disabled="infoMsg.disabled">提交</el-button>
            <div class="errMsg" v-if="infoMsg.checked">请勾选隐私条款</div>
          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="checked" style="font-size:12px;color: #797979;" @change="onChecked">我已仔细阅读《<a class="form-link" href="javascript:void(0);" style="color: #0066ff;">隐私声明</a>》和同意《<a class="form-link" href="javascript:void(0);" style="color: #0066ff;">使用条款</a>》</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive, ref, watchEffect} from "vue";
import $ from 'jquery';
import axios from 'axios';
import CheckCode from "@/view/login/components/checkCode.vue";
import { fa, tr } from "element-plus/es/locale";
import request from "@/service/request";
import {ElMessage,ElMessageBox} from "element-plus";
import router from "@/router";
// export default {
    components:{
      CheckCode
    }

let checked

const props = defineProps({
  visible: Boolean
})
// 自定义事件
const emit = defineEmits(['onClose'])
const visible = ref(props.visible);
const close = () => {
  emit('onClose', false)
}

 const info = reactive({
   name: '',
   telephone: '',
   code: '',
   email: '',
   position: ''
 });


let errMsgName = '请输入姓名'
let errMsgTelephone = '请输入手机号'
let errMsgCode = '请输入验证码'
let errMsgEmail = '请输入邮箱'
let errMsgPosition = '请输入职位'
let datasss = {}
let infoMsg = reactive({
  name: false,
  telephone: false,
  code: false,
  email: false,
  checked: false,
  position: false,
  disabled: false,
  disabledCode: true
});
const handleInput = (val) => {
  console.log(val);
  
  var result = val.replace(/\d+/g, "");
  console.log(result); // 输出 "abcdef"
  info.position = result
}
const inputName = () => {
   if (info.name == '') {
    console.log('7777777');
    
      errMsgName = '请输入姓名'
      infoMsg.name = true
   } else {
    console.log('5555555');
    queryByName()
   }
}
async function queryByName(){
  if (info.name == '') {
    console.log('12121121221-----------------9');
    infoMsg.name = true
    errMsgName = '请输入姓名'
  } else {
    // infoMsg.name = false
    // axios.get(process.env.VUE_APP_BASE_API +"/account/queryByName?name=" + info.name)
    // .then(response => {
    //   let res = response.data
    //   if (res.code == 200) {
    //     if (res.data == '0') {
    //       infoMsg.name = false
    //     } else {
    //       errMsgName = '用户名已被使用'
    //       infoMsg.name = true
    //     }
    //   } else {
    //     errMsgName = '用户名已被使用'
    //       infoMsg.name = true
    //   }
    // })
  }
  
}

const inputPosition = () => {
  //  if (info.name == '') {
  //     errMsgPosition = '职位'
  //     infoMsg.position = true
  //  } else {
  //     infoMsg.position = false
  //  }
}

const onChecked = () => {
  if (checked == true) {
    infoMsg.checked = false
  } else {
    infoMsg.checked = true
  }
}

const inputCode = () => {
   if (info.code == '') {
      infoMsg.code = true
   } else {
      infoMsg.code = false
   }
}

const inputEmail = () => {
  console.log('===================');
  var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
   let index = emailRegex.test(info.email)
   console.log(index);
   if (!index) {
      errMsgEmail = '请输入正确的邮箱'
      infoMsg.email = true
      console.log('88///////////////');
      console.log(infoMsg.email);
   } else {
      infoMsg.email = false
   }
}


const inputPhone = () => {
  console.log('===================');
   let index = /^1\d{10}$/.test(info.telephone)
   console.log(index);
   if (!index) {
      errMsgTelephone = '请输入正确的手机号'
      infoMsg.telephone = true
      infoMsg.disabledCode = true
      console.log('88///////////////');
      console.log(infoMsg.telephone);
   } else {
      infoMsg.telephone = false
      infoMsg.disabledCode = false
   }
   queryByPhone()
}

async function queryByPhone(){
  // axios.get(process.env.VUE_APP_BASE_API +"/account/queryByPhone?phone=" + info.telephone)
  //   .then(response => {
  //     let res = response.data
  //     if (res.code == 200) {
  //       console.log('11111111111111111111111111111111111111111');
        
  //       if (res.data == '0') {
  //         infoMsg.telephone = false
  //       } else {
  //         errMsgTelephone = '手机号已被使用'
  //         infoMsg.telephone = true
  //         infoMsg.disabledCode = true
  //       }
  //     } else {
  //         errMsgTelephone = '手机号已被使用'
  //         infoMsg.telephone = true
  //         infoMsg.disabledCode = true
  //     }
  //   })
}

watchEffect(() => {
  visible.value = props.visible;
})
const  submit = () => {

  var _this = this
  let flag = true
  console.log('111111111222222222222');
  console.log(infoMsg);
  

  // queryByName()
  // queryByPhone()
  if (infoMsg.name == true) {
   flag = false
  }
  inputEmail()
  if (infoMsg.email == true) {
    flag = false
  }
  
  console.log(checked);
  
  
  console.log('12121121221');
  
  if (info.name == '') {
    console.log('12121121221-----------------');
    infoMsg.name = true
    errMsgName = '请输入姓名'
    flag = false
  } else {
    infoMsg.name = false
  }



  if (checked != true) {
    infoMsg.checked = true
    flag = false
  } else {
    infoMsg.checked = false
  }
  if (info.telephone == '') {
    flag = false
    infoMsg.telephone = true
    errMsgTelephone = '请输入手机号'
  }

  if (infoMsg.telephone == true) {
    flag = false
  }

  
  if (info.code == '') {
    flag = false
    infoMsg.code = true
  } else {
    infoMsg.code = false
  }
  if (info.email == '') {
    flag = false
    infoMsg.email = true
  }
  if (infoMsg.email == true) {
    flag = false
  }
  // if (info.position == '') {
  //   flag = false
  //   infoMsg.position = true
  // } else {
  //   infoMsg.position = false
  // }
  
  if (flag) {
    infoMsg.disabled = true
    setTimeout(function(){
      console.log("大聪明码农徐");
      infoMsg.disabled = false
    // 时间间隔
    },1500);
    
    console.log("--------------------------------------------------------------------------");
    
    axios.post(process.env.VUE_APP_BASE_API +"/account/accountApplication", info)
    .then(response => {
      let res = response.data
      console.log('.......2222222222222222222222.........');
      // console.log(this.info);
      // console.log(_this.info);
      console.log(info);
      
      if (res.code == 200) {
        // ElMessage({
        //   message: '申请成功，等待管理员审核',
        //   type: 'success',
        //   duration: 3000,
        //   onClose: () => {

        //   }
        // });
        ElMessageBox.alert('申请成功，等待管理员审核', '成功', {
        confirmButtonText: 'OK',
        callback: () => {
          // ElMessage({
          //   type: 'info',
          //   message: `action: `,
          // })
          emit('onClose', false)
        },
      })
        console.log('66666666666666666666666666666');
        // info.name = ''
        // info.telephone = ''
        // info.code = ''
        // info.email = ''
        // info.checked = ''
        // info.position = ''
        // checked = false

        // console.log('77777777777777777');
        // console.log(info);
        // emit('onClose', false)
      } else {
          ElMessage({
          message: res.msg,
          type: 'error',
          duration: 3000,
          onClose: () => {

          }
        });
      }
      
    })
    

    // let {data} = request({
    // url: '/account/accountApplication',
    // method: "post",
    // data: info
  // })
  console.log('555555555555555555555555');
  // console.log(data);
  
  
  
  }
  
}

</script>

<style lang="less" scoped>
.account-shadow{
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 9;

  display: flex;
  align-items: center;
  justify-content: center;
}
.account-container{
  background-color: #fff;
  width: 438px;
  border-radius: 6px;
  padding: 0 20px 20px;
  position: relative;
}

.close{
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: -4px;
  font-size: 30px;
}

.desc{
  text-align: center;
  font-size: 20px;
  color: #3560cb;
  padding-top: 15px;
}

.tips{
  font-size: 12px;
  color: orange;
  margin-top: 16px;
}

.form{
  color: #a7b4bd;
  font-size: 16px;
  margin-top: 20px;
}
.el-form-item__content{
      
      flex-wrap: nowrap !important;
      
}
.el-form--label-top .el-form-item {
  width: 388px !important;
}
.el-input {
  height: 35px;
}

::v-deep .el-input__wrapper{
  background-color: #e9f2ff;
}
::v-deep .el-checkbox__label {
  font-size: 12px !important;
}

::v-deep .el-form--default.el-form--label-top .el-form-item .el-form-item__label{
  font-size: 16px !important;
}


.errMsg {
  font-size: 13px;
  height: 13px;
  color: red;
}



</style>